export const formatCompactNumber = (value: number | string): string => {
	if (value === undefined || value === null || value === '') return '0';
	const num = typeof value === 'string' ? parseFloat(value) : value;
	if (isNaN(num)) return '0';

	if (num >= 1_000_000_000) {
		return `${(num / 1_000_000_000).toFixed(1).replace(/\.0$/, '')}B`;
	}
	if (num >= 1_000_000) {
		return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
	}
	if (num >= 1_000) {
		return `${(num / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
	}
	return num.toLocaleString();
};

export const formatWithCommas = (value: number | string): string => {
	if (value === undefined || value === null || value === '') return '0';
	const num = typeof value === 'string' ? parseFloat(value) : value;
	if (isNaN(num)) return '0';
	return num.toLocaleString();
};
